import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PushMessageDetailsModel} from "./push-message-details.model";
import {PushMessageDetailsService} from "./push-message-details.service";
import {EnumModel} from "../../shared/objects/EnumModel";
import {Toast, ToasterService} from "angular2-toaster";
import {PushMessageEventSearchPipe} from './push-message-details-event-search.pipe';
import {PushMessageBarSearchPipe} from './push-message-details-bar-search.pipe';
import {PushMessageVenueSearchPipe} from './push-message-details-venue-search.pipe';

@Component({
  selector: 'app-push-message-details',
  templateUrl: './push-message-details.component.html',
  styleUrls: ['./push-message-details.component.less'],
  providers: [PushMessageDetailsService, PushMessageEventSearchPipe, PushMessageVenueSearchPipe]
})
export class PushMessageDetailsComponent implements OnInit {
  @Input() pushMessageId: number;
  @Output() showPushMessageClosed = new EventEmitter<boolean>();
  something = {};
  activeTab = 1;
  now = new Date();

  title = '';
  message = '';
  screenCode: EnumModel;
  venueId = '';
  eventId = '';
  

  venueOptions: any[];
  barOptions: any[];
  eventOptions: any[];

  buttonsEnabled = true;


  showDeleteConfirmation = false;
  showVenuePicker = false;
  showBarPicker = false;
  showEventPicker = false;
 
  model: any;

  screenCodeList: Array<EnumModel>;
  

  appResponseAttending = '';
  appResponseWaitingList = '';
  files: any[];

  initialState: string;
  showCloseConfirmation = false;
  closeRefreshState = false;
  loaded: boolean;

  searchEventString = '';
  searchVenueString = '';

  constructor(private service: PushMessageDetailsService, private toasterService: ToasterService) {
  }

  ngOnInit() {

    this.model = new PushMessageDetailsModel();

    this.screenCodeList = [{
      id: "Main",
      name: "Restaurants"
    },{
      id: "Bars",
      name: "Bars"
    },{
      id: "Restaurant",
      name: "Restaurant"
    },{
      id: "Bar",
      name: "Bar"
    },{
      id: "Map",
      name: "Map"
    },{
      id: "Access",
      name: "Access List"
    },{
      id: "Access",
      name: "Access"
    },{
      id: "Nightkey Card",
      name: "Nightkey"
    },{
      id: "Profile",
      name: "Profile"
    },{
      id: "Premium",
      name: "Premium"
    },{
      id: "Help",
      name: "Help"
    },{
      id: "Invite",
      name: "Invite"
    }];
  
    this.screenCode = EnumModel.GetByIdOrFirst(this.screenCodeList, "Main");
    
    this.service.getVenues(1).subscribe(
      (response) => {
        this.venueOptions = response;
        this.selectVenue(this.venueOptions[0]);
      }
    )

    this.service.getVenues(2).subscribe(
      (response) => {
        this.barOptions = response;
        this.selectVenue(this.barOptions[0]);
      }
    )

    this.service.getEvents().subscribe(
      (response) => {
        this.eventOptions = response;
        this.selectEvent(this.eventOptions[0]);
      }
    )
  }

  selectVenue(venue: any) {
    this.venueId = venue.id;
    
    this.showVenuePicker = false;
  }

  selectBar(venue: any) {
    this.venueId = venue.id;
    
    this.showBarPicker = false;
  }

  selectEvent(event: any) {
    this.eventId = event.id;
    
    this.showEventPicker = false;
  }

  initFromModel() {
    this.title = this.model.name;
    this.message = this.model.mesage;
    this.screenCode = this.model.screenCode;

  }

 



  close(refresh = false) {

    if (this.buttonsEnabled) {
      
        this.closeConfirmed();
      
    }
  }

  closeConfirmed() {
    this.showPushMessageClosed.emit(this.closeRefreshState);
  }





  save() {
    this.populateModel();
    this.saveOrUpdate();
  }

  populateModel() {
    this.model.title = this.title;
    this.model.message = this.message;

    if(this.screenCode.name == "Restaurant"){
      this.model.screenCode = this.screenCode.id+":"+this.venueId;    
    }else if(this.screenCode.name == "Bar"){
      this.model.screenCode = this.screenCode.id+":"+this.venueId;    
    }
    else if(this.screenCode.name == "Access"){
      this.model.screenCode = this.screenCode.id+":"+this.eventId;    
    }
    else{
      this.model.screenCode = this.screenCode.id;
    }
    this.closeRefreshState = true;
  }

  saveOrUpdate() {
    this.buttonsEnabled = false;
    
      this.service.new(this.model).subscribe(
        (id) => {

         this.closeConfirmed();

        }, (error) => {
          this.buttonsEnabled = true;
        });
    
  }





  closePopUp() {
    this.showDeleteConfirmation = false;
    this.showCloseConfirmation = false;
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-message-details/push-message-details.component.ts